import { chakra, FormControl, FormLabel } from '@chakra-ui/react';
import { MultiSelect, reactSelectStyles } from '@diamond/shared/ui';
import { useFormContext } from 'react-hook-form';

import { useCustomerTypes, useDistributionChannel } from '../api';

export function CustomerTypeInput() {
  const { setValue, watch } = useFormContext();

  const { options: customerTypeOptions } = useCustomerTypes();
  const { options: distributionChannelOptions } = useDistributionChannel();

  const selectedBusinessSegmentationCodes: string[] =
    (watch('business_segmentation') as string[]) || [];
  const selectedDistributionChannelCodes: string[] =
    (watch('distribution_channel') as string[]) || [];

  return (
    <>
      <FormControl>
        <FormLabel
          aria-label="Tipe Customer (Opsional)"
          htmlFor="business_segmentation"
        >
          Tipe Customer <chakra.span color="gray.75">(Opsional)</chakra.span>
        </FormLabel>
        <MultiSelect
          id="business_segmentation"
          placeholder="Semua Tipe Customer"
          chakraStyles={reactSelectStyles}
          options={customerTypeOptions}
          value={customerTypeOptions.filter((o) =>
            selectedBusinessSegmentationCodes.includes(o.value)
          )}
          onChange={(vals) => {
            const codes = (vals || []).map((v) => v.value);
            setValue('business_segmentation', codes, {
              shouldDirty: true,
              shouldValidate: true,
            });
          }}
        />
      </FormControl>
      <FormControl>
        <FormLabel
          aria-label="Cabang (Opsional)"
          htmlFor="distribution_channel"
        >
          Cabang <chakra.span color="gray.75">(Opsional)</chakra.span>
        </FormLabel>
        <MultiSelect
          id="distribution_channel"
          placeholder="Semua Cabang"
          chakraStyles={reactSelectStyles}
          options={distributionChannelOptions}
          value={distributionChannelOptions.filter((o) =>
            selectedDistributionChannelCodes.includes(o.value)
          )}
          onChange={(vals) => {
            const codes = (vals || []).map((v) => v.value);
            setValue('distribution_channel', codes, {
              shouldDirty: true,
              shouldValidate: true,
            });
          }}
        />
      </FormControl>
    </>
  );
}
